import React from 'react';
import { FileText, CreditCard, CheckCircle2, ArrowRight } from 'lucide-react';
import { openChat } from '../utils/chat';

export const Process = ({ onOpenForm }) => {
  const steps = [
    {
      id: 1,
      title: 'Provide Your Trademark Details',
      description: 'Share your trademark information, including the name, logo, and intended use. Our team will review your submission to ensure we have everything needed to move forward.',
      icon: FileText,
    },
    {
      id: 2,
      title: 'Choose Your Service and Complete Payment',
      description: 'Select the protection package that best fits your needs from our transparent pricing options. Complete your secure payment to begin the registration process.',
      icon: CreditCard,
    },
    {
      id: 3,
      title: 'Comprehensive Evaluation and Filing',
      description: 'Our experienced IP attorneys conduct a thorough evaluation, prepare your application with precision, and file it with the appropriate trademark office on your behalf.',
      icon: CheckCircle2,
    },
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="text-[#D4AF37] font-semibold text-sm uppercase tracking-wider">How It Works</span>
          <h2 className="text-4xl md:text-5xl font-bold text-[#0A1F44] mt-4 mb-6">
            Simple 3-Step Process
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Protecting your trademark has never been easier. Follow our streamlined process to secure your intellectual property rights.
          </p>
        </div>

        {/* Process Steps */}
        <div className="relative">
          {/* Connection Line */}
          <div className="hidden md:block absolute top-24 left-0 right-0 h-1 bg-gradient-to-r from-[#D4AF37] via-[#D4AF37] to-[#D4AF37] opacity-20" style={{ width: 'calc(100% - 200px)', left: '100px' }}></div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative">
            {steps.map((step, index) => {
              const Icon = step.icon;
              
              return (
                <div
                  key={step.id}
                  className="relative bg-gray-50 rounded-2xl p-8 hover:shadow-xl transition-all duration-300 group"
                >
                  {/* Icon */}
                  <div className="flex justify-center mb-6">
                    <div className="w-20 h-20 bg-[#0A1F44] rounded-2xl flex items-center justify-center group-hover:bg-[#D4AF37] transition-colors duration-300">
                      <Icon className="w-10 h-10 text-[#D4AF37] group-hover:text-[#0A1F44]" />
                    </div>
                  </div>

                  {/* Content */}
                  <div className="text-center">
                    <h3 className="text-xl font-bold text-[#0A1F44] mb-4">
                      {step.title}
                    </h3>
                    <p className="text-gray-600 leading-relaxed">
                      {step.description}
                    </p>
                  </div>

                  {/* Arrow Indicator (not on last step) */}
                  {index < steps.length - 1 && (
                    <div className="hidden md:block absolute -right-4 top-1/2 transform -translate-y-1/2 z-10">
                      <div className="w-8 h-8 bg-white rounded-full flex items-center justify-center shadow-md">
                        <ArrowRight className="w-5 h-5 text-[#D4AF37]" />
                      </div>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>

        {/* Bottom CTA */}
        <div className="mt-16 text-center">
          <p className="text-gray-600 text-lg mb-6">
            Ready to protect your brand? Start your trademark registration today.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <button
              onClick={onOpenForm}
              className="liquid inline-block bg-[#D4AF37] hover:bg-[#B8941F] text-[#0A1F44] font-bold py-4 px-8 rounded-lg text-lg"
            >
              Start Trademark Registration
            </button>
            <button
              onClick={openChat}
              className=" js-chat liquid-outline inline-block bg-transparent hover:bg-[#D4AF37] text-[#0A1F44] border-2 border-[#0A1F44] hover:border-[#D4AF37] font-bold py-4 px-8 rounded-lg text-lg"
            >
              Discuss with Attorney
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};
